import { a as r } from "./array-buffer-view-core.js";
import { s as t } from "./species-constructor.js";
var o = r.aTypedArrayConstructor,
  e = r.getTypedArrayConstructor,
  s = function s(r) {
    return o(t(r, e(r)));
  };
export { s as t };